import { ICompanyAlertSettings } from './company-alert-settings.interface';

export class CompanyAlertSettings implements ICompanyAlertSettings {
  companySettingsId: Array<string> = [];
  companyId: string;
  alertContactEmail: string;
  alertMinus90Days: boolean;
  alertMinus60Days: boolean;
  alertMinus30Days: boolean;
  alertMinus14Days: boolean;
  alert0Days: boolean;
  alert14Days: boolean;

  constructor(iCompanyAlertSettings: ICompanyAlertSettings = null) {
    this.companySettingsId = iCompanyAlertSettings?.companySettingsId;
    this.companyId = iCompanyAlertSettings?.companyId;
    this.alertMinus90Days = iCompanyAlertSettings?.alertMinus90Days;
    this.alertMinus60Days = iCompanyAlertSettings?.alertMinus60Days;
    this.alertMinus30Days = iCompanyAlertSettings?.alertMinus30Days;
    this.alertMinus14Days = iCompanyAlertSettings?.alertMinus14Days;
    this.alert0Days = iCompanyAlertSettings?.alert0Days;
    this.alert14Days = iCompanyAlertSettings?.alert14Days;
  }

}
